/* eslint-disable radix */
if (!customElements.get("filter-price")) {
  class FilterPriceElement extends HTMLElement {
    init(min, max) {
      this.maxPrice = parseFloat(max);
      this.minPrice = parseFloat(min);
      this.inputsHandler();
    }

    disconnectedCallback() {
      this.cleanupEventListeners();
    }

    // Method to handle input changes for min and max values
    inputsHandler() {
      this.inputMin = this.querySelector(".filter-price-inputs__min input");
      this.inputMax = this.querySelector(".filter-price-inputs__max input");
      this.rangeMinInput = this.querySelector(".range-slider__input-left");
      this.rangeMaxInput = this.querySelector(".range-slider__input-right");

      this.isUpdating = false; // Flag to prevent circular updates

      // Event listeners for change on inputMin and inputMax
      this.inputMin.addEventListener("change", (e) => this.handleMinInput(e));
      this.inputMax.addEventListener("change", (e) => this.handleMaxInput(e));

      // Event listeners for input on rangeMinInput and rangeMaxInput
      this.rangeMinInput.addEventListener("input", (e) => this.handleMinSliderInput(e));
      this.rangeMaxInput.addEventListener("input", (e) => this.handleMaxSliderInput(e));

      this.inputMin.dispatchEvent(
        new CustomEvent("change", {
          bubbles: false,
          cancelable: true,
          detail: { message: "init" },
        }),
      );

      this.inputMax.dispatchEvent(
        new CustomEvent("change", {
          bubbles: false,
          cancelable: true,
          detail: { message: "init" },
        }),
      );
    }

    // Cleanup event listeners when component is disconnected
    cleanupEventListeners() {
      this.inputMin.removeEventListener("change", this.handleMinInput);
      this.inputMax.removeEventListener("change", this.handleMaxInput);
      this.rangeMinInput.removeEventListener("input", this.handleMinSliderInput);
      this.rangeMaxInput.removeEventListener("input", this.handleMaxSliderInput);
    }

    // Handle the min price input field change
    handleMinInput(e) {
      if (this.isUpdating) return; // Prevent circular updates

      const minValue = parseFloat(e.target.value);

      // Ensure minValue is within valid range and less than inputMax
      if (minValue < this.maxPrice && minValue >= this.minPrice && minValue <= parseFloat(this.inputMax.value)) {
        this.updateSliderValue(this.rangeMinInput, minValue);
        this.isUpdating = true;
        this.rangeMinInput.dispatchEvent(new Event("input", { bubbles: true, cancelable: true }));
        this.isUpdating = false;
      } else {
        // Reset inputMin and update the range slider to 0 or the min value
        this.inputMin.value = "";
        this.updateSliderValue(this.rangeMinInput, 0); // Reset to 0 or the min value
        this.isUpdating = true;
        this.rangeMinInput.dispatchEvent(new Event("input", { bubbles: true, cancelable: true }));
        this.isUpdating = false;
      }
    }

    // Handle the max price input field change
    handleMaxInput(e) {
      if (this.isUpdating) return; // Prevent circular updates

      const maxValue = parseFloat(e.target.value);

      // Ensure maxValue is within valid range and greater than or equal to inputMin
      if (
        maxValue <= this.maxPrice &&
        maxValue > parseFloat(this.minPrice) &&
        maxValue >= parseFloat(this.inputMin.value)
      ) {
        this.updateSliderValue(this.rangeMaxInput, maxValue);
        this.isUpdating = true;
        this.rangeMaxInput.dispatchEvent(new Event("input", { bubbles: true, cancelable: true }));
        this.isUpdating = false;
      } else {
        // Reset inputMax and update the range slider to max price
        this.inputMax.value = this.maxPrice.toFixed(2); // Set max to default if invalid
        this.updateSliderValue(this.rangeMaxInput, this.maxPrice); // Reset the range slider to max value
        this.isUpdating = true;
        this.rangeMaxInput.dispatchEvent(new Event("input", { bubbles: true, cancelable: true }));
        this.isUpdating = false;
      }
    }

    // Handle the min slider input
    handleMinSliderInput(e) {
      if (this.isUpdating) return; // Prevent circular updates
      const rangeValue = parseFloat(e.target.value);
      let minValue = (rangeValue / 100) * this.maxPrice;

      // Ensure minValue is within valid range and does not surpass maxValue
      minValue = Math.min(Math.max(minValue, this.minPrice), parseFloat(this.inputMax.value));

      this.isUpdating = true;
      this.inputMin.value = minValue.toFixed(2);
      this.isUpdating = false;
    }

    // Handle the max slider input
    handleMaxSliderInput(e) {
      if (this.isUpdating) return; // Prevent circular updates

      const rangeValue = parseFloat(e.target.value);
      let maxValue = (rangeValue / 100) * this.maxPrice;

      // Ensure maxValue is within valid range and does not fall below minValue
      maxValue = Math.min(Math.max(maxValue, parseFloat(this.inputMin.value)), this.maxPrice);

      this.isUpdating = true;
      this.inputMax.value = maxValue.toFixed(2);
      this.isUpdating = false;
    }

    // Helper method to update slider value
    updateSliderValue(slider, value) {
      // eslint-disable-next-line no-param-reassign
      slider.value = (value / this.maxPrice) * 100; // Set the range slider value as a percentage of maxPrice
    }
  }

  customElements.define("filter-price", FilterPriceElement);
}
